import React, { useState, useEffect } from 'react';
import '../App.css';
import { ResponsiveBar } from '@nivo/bar';
import { useRecoilState } from 'recoil';
import { mainBlueColor } from '../GlobalState';
import { currencyStyle } from '../utils/common';

type GraphStatus = {
  date: string;
  target_value: number;
  actual_value: number;
  achievement_rate: number;
};

type GraphStatuses = {
  start_date_year: number;
  start_date_month: number;
  end_date_year: number;
  end_date_month: number;
  actual_sales_amount: number;
  max_target_value: number;
  currency: number;
  graphStatus: GraphStatus[];
};

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

const PeriodBarGraph: React.FC<GraphStatuses> = graphStatuses => {
  const [mainColor] = useRecoilState(mainBlueColor);

  const [windowDimensions, setWindowDimensions] = useState<any>(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ overflow: 'scroll' }} className='period-bar-graph-container'>
      <div className='bottom-bar-graph-top-container'>
        <div>
          <div style={{ fontSize: 14 }}>
            {graphStatuses.start_date_year}年{graphStatuses.start_date_month}月~
            {graphStatuses.end_date_year}年{graphStatuses.end_date_month}
            月総売上
          </div>
          <div style={{ fontWeight: 'bold', fontSize: 24 }}>
            {currencyStyle(
              graphStatuses.actual_sales_amount,
              graphStatuses.currency
            )}
          </div>
        </div>
        <div className='bottom-bar-graph-top-container'>
          <div className='square' style={{ backgroundColor: '#CCCCCC' }} />
          <div className='mg-bottom'>目標</div>
          <div className='square' style={{ backgroundColor: '#FFFFFF' }} />
          <div className='square' style={{ backgroundColor: mainColor }} />
          <div className='mg-bottom'>進捗</div>
        </div>
      </div>

      <div
        key={graphStatuses.graphStatus.toString()}
        style={{
          height: 350,
          minWidth: windowDimensions.width - 100,
          width: graphStatuses.graphStatus.length * 100
        }}
      >
        <ResponsiveBar
          groupMode='grouped'
          data={graphStatuses.graphStatus}
          keys={['target_value', 'actual_value']}
          indexBy='date'
          margin={{
            top: 20,
            right: 40,
            bottom: 30,
            left:
              Math.max(
                graphStatuses.actual_sales_amount,
                graphStatuses.max_target_value
              ).toString().length <= 1
                ? 40
                : Math.max(
                    graphStatuses.actual_sales_amount,
                    graphStatuses.max_target_value
                  ).toString().length * 9
          }}
          padding={0.3}
          valueScale={{ type: 'linear' }}
          indexScale={{ type: 'band', round: true }}
          colors={['#CCCCCC', mainColor]}
          borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
          label={''}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
          animate={true}
          motionConfig={{
            mass: 1,
            tension: 90,
            friction: 15,
            clamp: false,
            precision: 0.01,
            velocity: 0
          }}
          axisBottom={{ tickSize: 5 }}
          tooltip={({ value, color, indexValue }) => {
            return (
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                  backgroundColor: 'white',
                  padding: '0.25rem'
                }}
              >
                {' '}
                <div className='square' style={{ backgroundColor: color }} />
                <div>
                  {indexValue}
                  {' : '}
                  <span style={{ fontWeight: 'bold' }}>
                    {value.toLocaleString()}
                  </span>
                </div>
              </div>
            );
          }}
        />
      </div>
    </div>
  );
};
export default PeriodBarGraph;
